// Packages
import axios from 'axios'

export const refreshPageMixin = {
  data () {
    return {
      currentHash: '',
      newHash: '',
      hashChanged: false,
    }
  },

  methods: {
    async checkVersion (url) {
      // This comment is for regression testing only
      // This comment is for regression testing only
      // This comment is for regression testing only
      // This comment is for regression testing only

      try {
        const fileResponse = await axios.get(url)

        this.currentHash = process.env.VUE_APP_GIT_RELEASE_VERSION
        this.newHash = fileResponse.data.split('\n')[0]
        this.hashChanged = this.hasHashChanged(this.currentHash, this.newHash)
      }
      catch (error) {
        // We don't want to show the modal in case of errors
        this.hashChanged = false
      }
    },

    hasHashChanged (currentHash, newHash) {
      if (!currentHash) {
        return true
      }

      return currentHash !== newHash
    },

    initVersionCheck (url, frequency = 1000 * 60 * 50) {
      // run this check every hour
      setInterval(() => {
        this.checkVersion(url)
      }, frequency)
    },

    reloadApp () {
      this.currentHash = this.newHash
      window.location.reload()
    },
  },
}
